export const ROOT = "/admin/private";

export const SUSPENDED = `${ROOT}/suspended`;
export const DEACTIVATED = `${ROOT}/deactivated`;
export const SIGN_UP_STEPS = `${ROOT}/sign-up-steps`;
